export const LogoMark = ({ className = "h-11 w-auto" }) => (
  <img src="/sss-logo.png" alt="SSS GROUPS logo" className={`${className} rounded-lg`} />
);

export const Logo = ({ light = true }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark className="h-11 w-auto shadow-sm" />
    <span className="leading-tight">
      <span className={`block font-serif text-base font-bold tracking-wide ${light ? "text-white" : "text-navy-900"}`}>
        SIREE SOLUTIONS GROUPS
      </span>
      <span className="block font-mono text-[9px] font-semibold uppercase tracking-[0.24em] text-gold">
        Together for a Better Tomorrow
      </span>
    </span>
  </span>
);
